<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-08 18:39:46
 * @LastEditTime: 2022-03-01 19:41:08
 * @LastEditors: chenguobiao
-->
<template>
  <div class="dialog" v-if="visible">
    <div class="dialog__masker"></div>
    <div class="dialog__box" v-if="product">
      <div class="dialog__title">
        <span class="line--bar"></span><span>使用激活码</span><span class="line--bar"></span>
      </div>
      <div class="dialog__info">
        <el-form :model="formData" :rules="rules" ref="formRef" :hide-required-asterisk="true">
          <!-- <el-form-item label="激活卡账号" prop="cardNo">
            <el-input v-model="formData.cardNo" placeholder="请输入" />
          </el-form-item> -->
          <el-form-item label="激活码" prop="activateCode">
            <el-input v-model="formData.activateCode" placeholder="请输入激活码" />
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog__options">
        <div class="apply--button" @click="verification">核销</div>
        <div class="close" @click="close">
          <img src="@/render/assets/images/home/close_grading_notice.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import dialogMixin from './mixin'
import { gradingAPI } from '@/apis'
export default {
  mixins: [dialogMixin],
  props: {
    product: {
      type: Object
    }
  },
  data() {
    return {
      formData: {
        activateCode: "",
      },
      rules: {
        activateCode: [{ required: true, message: '请输入激活码', trigger: 'blur' }],
      }
    }
  },
  methods: {
    verification: _.throttle(async function () {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          await gradingAPI.useActivateCard({
            ...this.formData,
            productUid: this?.product?.uid
          })
          this.$emit('success')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./dialog.scss";

.dialog {
  &__box {
    padding: val(24) 0 val(46);
    width: val(500);
    height: val(280);
    background: url('../../assets/images/home/use_activate_card_bg.png') no-repeat left top;
    background-size: 100%;
  }

  &__title {
    margin-bottom: val(78);
    text-align: center;
    font-size: val(24);
    line-height: val(24);
    color: #B16012;
    display: flex;
    justify-content: center;
    align-items: center;

    .line--bar {
      margin: 0 val(10);
      width: val(20);
      height: val(1);
      background: url(../../assets/images/home/line_bar.png) left top no-repeat;
      background-size: 100%;

      &:first-of-type {
        transform: rotate(180deg);
      }
    }
  }

  &__info {
    ::v-deep {
      .el-form {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .el-form-item {
        margin-bottom: val(20);

        .el-form-item__label {
          width: val(80);
          padding-right: val(12);
          line-height: val(32);
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: val(20);
          color: #502700;
          font-style: normal;
          text-transform: none;
        }

        .el-form-item__content {
          margin-left: val(120);
          line-height: val(32);
          font-size: val(14);

        }

        .el-input {
          width: val(200);
          font-size: val(14);
        }

        .el-input__inner {
          background-color: transparent;
          height: val(32);
          line-height: val(32);
          border-color: #502700;
          border-radius: val(2);
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: val(14);
          color: #7C552E;
          line-height: val(22);
          text-align: left;
          font-style: normal;
          text-transform: none;
          padding-left: val(12);

          &::placeholder {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: val(14);
            color: rgba(124, 85, 46, 0.5);
            line-height: val(22);
            text-align: left;
            font-style: normal;
          }
        }

        .el-form-item__error {
          padding-top: val(4);
          font-size: val(16);
        }
      }
    }
  }

  &__options {
    position: absolute;
    bottom: val(28);
    left: 0;
    right: 0;
    transform: translateY(100%);
    display: flex;
    flex-direction: column;
    align-items: center;

    .apply--button {
      cursor: pointer;
      margin-bottom: val(7);
      width: val(218);
      line-height: val(56);
      text-align: center;
      border-radius: val(37);
      background: linear-gradient(360deg, #B26113 0%, #FDAE5F 100%);
      font-size: val(24);
      color: #FFFFFF;
      text-shadow: 3.773547887802124px 3.2802951335906982px 9px rgba(178, 94, 12, 0.3);

      &.disabled {
        color: #6A6A6A;
        background: linear-gradient(360deg, #8D8D8D 0%, #C1C1C1 56%, #E9E9E9 100%);
        text-shadow: unset;
      }
    }

    .close {
      cursor: pointer;
      width: val(42);
    }
  }
}
</style>
